import React, { Component, useRef, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import { Col, Form, FormGroup, Row } from "reactstrap";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import moment from "moment";
import { checkInput, convertHHMMForBackend, prepareForBackend, SetupPageWithBFCacheAndPrompt, compressImageSmart, sanitizeEncodeImage } from "../lib/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

import {
  SymptomLight,
  FoodLight,
  ActivityLight,
  PCPLight,
  MedicineLight,
  SupplementLight,
  LocationLight,
} from "../components/CustomIcon";

import {
  Dropdown,
  InputAmount,
  InputText,
  ListingText,
  Loading,
  Valert,
  VautoComplete,
  DateTimePicker,
  Vmodal,
  InputHHMM,
} from "../components";

import symptomActions from "../actions/symptomActions";
import { getLoggedInUser, isLoggedIn } from "../services/AuthenticationService";
import {
  ACTIVITY_UNITS,
  DRUG_UNITS,
  FOOD_UNITS,
  LOC_UNITS,
  PCP_UNITS,
  SUP_UNITS,
  SYMPTOM_UNITS_NEW,
} from "../actions/constant";
import "./styles/symptoms.css";
import "./styles/symptomsModern.css";

const CategoryIconBar = ({
  value,
  disabled,
  onClick,
  t,
}) => {
  const cats = [
    { id: "01", label: t("general.CATEGORY_BUTTON_SYMPTOM"), type: "custom", iconLight: SymptomLight, iconSolid: SymptomLight },
    { id: "02", label: t("general.CATEGORY_BUTTON_FOOD"), type: "custom", iconLight: FoodLight, iconSolid: FoodLight },
    { id: "03", label: t("general.CATEGORY_BUTTON_ACTIVITY"), type: "custom", iconLight: ActivityLight, iconSolid: ActivityLight },
    { id: "04", label: t("general.CATEGORY_BUTTON_PCP"), type: "custom", iconLight: PCPLight, iconSolid: PCPLight },
    { id: "05", label: t("general.CATEGORY_BUTTON_MEDICINE"), type: "custom", iconLight: MedicineLight, iconSolid: MedicineLight },
    { id: "06", label: t("general.CATEGORY_BUTTON_SUPPLEMENT"), type: "custom", iconLight: SupplementLight, iconSolid: SupplementLight },
    { id: "07", label: t("general.CATEGORY_BUTTON_LOCATION"), type: "custom", iconLight: LocationLight, iconSolid: LocationLight },
  ];

  const [showId, setShowId] = useState(null);             // which tooltip is visible (mobile long-press)
  const stateRef = useRef({ timer: null, longActive: false, suppressClickUntil: 0 });

  const LONG_PRESS_MS = 500;
  const SUPPRESS_CLICK_MS = 350;
  const HIDE_AFTER_RELEASE_MS = 900;

  const startLongPress = (id) => {
    if (disabled) return;
    clearTimeout(stateRef.current.timer);
    stateRef.current.longActive = false;
    stateRef.current.timer = setTimeout(() => {
      stateRef.current.longActive = true;
      setShowId(id);
    }, LONG_PRESS_MS);
  };

  const endLongPress = () => {
    clearTimeout(stateRef.current.timer);
    if (stateRef.current.longActive) {
      // show for a short while after finger is lifted, then hide
      stateRef.current.suppressClickUntil = Date.now() + SUPPRESS_CLICK_MS;
      setTimeout(() => setShowId(null), HIDE_AFTER_RELEASE_MS);
      stateRef.current.longActive = false;
    }
  };

  const handleClick = (id) => {
    if (disabled) return;
    // if we just long-pressed, suppress the click that usually fires after touchend
    if (Date.now() < stateRef.current.suppressClickUntil) return;
    onClick(id);
  };

  return (
    <div className="catbar-wrap" aria-label={t("symptoms.CATEGORY_TEXT")}>
      {cats.map((c) => {
        const active = String(value) === c.id;
        const showTooltip = showId === c.id;

        const iconColor = disabled ? "#ced4da" : (active ? "#ff0000" : "#007bff");
        const borderColor = disabled ? "#ced4da" : (active ? "#ff0000" : "#ced4da");
        const bgColor = disabled ? "#f1f3f5" : "#fff";

        return (
          <button
            key={c.id}
            type="button"
            className={`catbtn ${active ? "active" : ""}`}
            disabled={disabled}
            aria-pressed={active}
            // Desktop hover remains CSS-only
            onClick={() => handleClick(c.id)}
            // Mobile long-press handlers
            onTouchStart={() => startLongPress(c.id)}
            onTouchEnd={endLongPress}
            onTouchCancel={endLongPress}
            style={{ borderColor, backgroundColor: bgColor }}
          >
            {c.type === "fa" ? (
              <FontAwesomeIcon
                icon={active ? c.iconSolid : c.iconLight}
                className="catbtn-ico"
                style={{ color: iconColor }}
              />
            ) : c.type === "custom" ? (
              React.createElement(active ? c.iconSolid : c.iconLight, {
                className: "catbtn-ico",
                style: { color: iconColor }
              })
            ) : null}

            <span className={`tooltip ${showTooltip ? "show" : ""}`}>{c.label}</span>
          </button>
        );
      })}
    </div>
  );
};

class SymptomForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autocompleteValue: "",
      renderCounter: "",
      categoryValidator: "",
      autoValidator: "",
      scaleValidator: "",
      unitValidator: "",
      userValidator: "",
      scaleValue: "",
      unitValue: "",
      itemLabel: props.t("general.ITEM_INPUT_TEXT"),
      scaleLabel: props.t("general.ITEM_VALUE_TEXT"),
      enterHandel: true,
      selectedDetail: this.props.itemDetails ? this.props.itemDetails : {},
      forceShowHistory: false,
    };
    this.scaleOnChange = this.scaleOnChange.bind(this);
    this.unitOnChange = this.unitOnChange.bind(this);
    this.categoryOnChange = this.categoryOnChange.bind(this);
    this.searchNameOptions = this.searchNameOptions.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.checkItemSelected = this.checkItemSelected.bind(this);
    this.selectItemPos = this.selectItemPos.bind(this);
    this.onChangeSymptomForm = this.onChangeSymptomForm.bind(this);
    this.handleSemiColonInAmount = this.handleSemiColonInAmount.bind(this);

    this.selectItemClick = this.selectItemClick.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  selectUser(id) {
    this.props.selectUser(id);
    this.setState({ renderCounter: this.state.renderCounter++ });
  }

  onSuccess() {
    this.clearSymptom();
    setTimeout(() => {
      alert(this.props.t("general.SAVE_SUCCESSFULLY_TITLE"));
    }, 100);
  }

  keyPress(e) {
    if (e.keyCode == 13) {
      this.setState({ enterHandel: false });
    }
  }

  scaleOnChange(e) {
    var val = e.target.value;
    if (val || val != "null") {
      this.setState({ scaleValidator: "" });
    }
    return true;
  }

  onChangeSymptomForm(e) {
    if (e && e.target && e.target.name) {
      this.props.onChangeSymptomForm(e); // Traditional DOM-style event
    } else if (e && e.name && e.value !== undefined) {
      this.props.onChangeSymptomForm({
        target: {
          name: e.name,
          value: e.value,
        },
      }); // Manual object from InputHHMM
    }
  }

  unitOnChange(e) {
    var val = e.target.value == "null" ? "" : e.target.value;
    this.setState({
      unitValue: val,
    });
  }

  categoryClicked() {
    this.setState({ renderCounter: this.state.renderCounter++ });
  }

  searchNameOptions(e) {
    e.preventDefault();
    let val = e.target.value;
    this.setState({ autocompleteValue: val });
    this.props.searchNameOptions(val, this.props.symptomForm.category);
  }

  clearSymptom() {
    this.props.onVIdSelected(null); // instruct parent to clear VID

    // ✅ Reset itemChanged flag in Redux
    this.props.dispatch({ type: 'RESET_ITEM_CHANGED' });

    // Preserve user and clear other fields
    this.props.clearSymptom();

    this.setState({
      time: "",
      autocompleteValue: "",
      renderCounter: "",
      categoryValidator: "",
      autoValidator: "",
      scaleValidator: "",
      unitValidator: "",
      userValidator: "",
      scaleValue: "",
      unitValue: "",
    });
  }

  categoryOnChange(e) {
    this.props.categorySelected(e);
    if (e.target.value == "01") {
      this.setState({
        itemLabel: this.props.t("symptoms.ITEM_INPUT_TEXT_SYMPTOM"),
        scaleLabel: this.props.t("general.ITEM_VALUE_TEXT_SYMPTOM"),
      });
    } else {
      this.setState({
        itemLabel: this.props.t("general.ITEM_INPUT_TEXT"),
        scaleLabel: this.props.t("general.ITEM_VALUE_TEXT"),
      });
    }
    this.props.clearTime();
  }

  checkItemSelected(UserId, index) {
    var result = false;
    var { selectedList } = this.props;
    selectedList.forEach((element) => {
      if (UserId == element.user._id && element.index == index) {
        result = true;
      }
    });
    return result;
  }

  selectItemClick(item, vId) {
    let selectedDetail = { item: item, vId: vId };
    this.setState({ selectedDetail: selectedDetail });
    if (!this.props.onVIdSelected) return;

    // Step 1: Get currently selected vId from Redux
    const currentlySelectedVId =
      this.props.selectedItem && this.props.selectedItem.vId
        ? this.props.selectedItem.vId
        : null;

    // Step 2: Compare with clicked vId. If the user clicks on the same item that’s already selected, treat it as deselect
    const isDeselect = currentlySelectedVId === vId;

    const formItem = this.props.symptomForm;
    const selectedItem = this.props.selectedItem;
    const selectedVId = this.props.selectedVId;

    const isSelected = !!selectedVId;

    const formChanged =
      isSelected &&
      (
        this.props.itemChanged ||
        (formItem && selectedItem && formItem.name !== selectedItem.name) ||
        (formItem && selectedItem && formItem.category !== selectedItem.category)
      );

    const formHasNameOrUPC =
      formItem &&
      (
        (formItem.name && formItem.name.trim() !== "") ||
        (formItem.upc && formItem.upc.trim() !== "")
      );

    const isNewItem = !isSelected && formHasNameOrUPC;

    // ───────────────────────────────
    // 🧠 Prompt decision logic
    // ───────────────────────────────

    if (isSelected && formChanged) {
      // Case 1: User editing selected item and tries to select a different item or deselect the same item → CurrentItemNotUpdated
      this.CurrentItemNotUpdated.changeStatus();
      return;
    } else if (!isSelected && !this.props.disabled.addBtn && isNewItem) {
      // Case 2: User filling form for new item completely, but tries to select an item from Display Area → NewItemNotAdded
      this.NewItemNotAdded.changeStatus();
      return;
    } else if (!isSelected && this.props.disabled.addBtn && isNewItem) {
      // Case 3: User filling form for new item incompletely, but tries to select an item from Display Area → NewItemNotAdded      
      this.IncompleteNewItem.changeStatus();
      return;
    } else {
      // Step 3: Notify upstream. Pass the newly assigned (or cleared) vId to Redux or parent component
      this.props.onVIdSelected(isDeselect ? null : vId);
      this.props.selectItem(item, vId);
      this.props.clearTime();
    }
  }

  // We use forceClear = false as a default parameter so that:
  // ✅ 1. You can call selectItemPos() without any argument (normal behavior)
  //    >>> this.selectItemPos(); // behaves based on isDeselect logic
  //    — This is how it's used when the user clicks an item in the display area (inside SymptomForm), and we want it to conditionally clear only if the same item is clicked again.
  // ✅ 2. You can call selectItemPos(true) explicitly to force clear, regardless of vId
  //   >>> this.symptomFormRef.selectItemPos(true); // force clear
  //   — This is used in VAlert related to DeleteIconClicked, especially for delete icon confirmation prompts and new item not added prompts where we want to forcefully reset vId, even if no item is selected or a different one was clicked.

  // 🎯 Summary:
  // The forceClear = false makes selectItemPos() flexible:
  // -- By default: behaves like a toggle (deselect when clicking same item)
  // -- When needed: forcibly clear everything by passing true
  selectItemPos(forceClear = false) {
    const { item, vId } = this.state.selectedDetail;

    const currentlySelectedVId =
      this.props.selectedItem && this.props.selectedItem.vId
        ? this.props.selectedItem.vId
        : null;

    // Detects whether it's a deselection or new selection
    const isDeselect = currentlySelectedVId === vId;

    // isDeselect handles scenarios of deselecting
    // forceClear handles scenarios of delete icon clicked. For delete icon, regardless of which prompt, all the form fields should be cleared. Only user should be preserved.
    const shouldClear = forceClear || isDeselect;

    let user = null;
    // ✅ If vId is present and it exists in any user’s inputs, extract matching user IDs
    if (vId && this.props.users && Array.isArray(this.props.users)) {
      const matchedUsers = this.props.users.filter(
        (u) => u.inputs && u.inputs.some((input) => input.vId === vId)
      );

      user = matchedUsers.map((u) => u._id); // always array ✅
    }

    // Fallback to current symptomForm users (already flattened) if no match found
    if (!user || user.length === 0) {
      const userList = this.props.symptomForm && this.props.symptomForm.users;
      if (Array.isArray(userList) && userList.length > 0) {
        user = userList.flat(); // ensures it's always an array ✅
      }
    }

    // Extract correct item from displayItems
    const allDisplayItems = this.props.displayItems || [];
    const clickedItemFromDisplay = allDisplayItems.find((i) => i.vId === vId);

    if (shouldClear) {
      this.props.onVIdSelected(null); // instruct parent to clear

      // ✅ Normalize user
      if (!Array.isArray(user)) {
        user = [user];
      }

      this.props.dispatch({
        type: "SYMPTOMS_ITEM_SELECT",
        user: user,
        vId: null,
      });

    } else {
      this.props.onVIdSelected(vId);

      this.props.selectItem(user, vId);
    }

    this.props.dispatch({ type: "RESET_ITEM_CHANGED" });
    this.props.clearTime();
  }

  handleSemiColonInAmount(val) {
    const supportsHHMM = this.props.unitOptions.length > 0 && this.props.unitOptions.some((opt) => opt.value === "445");

    if (supportsHHMM && !this.props.hhmmMode) {
      // ✅ Switch to HHMM mode
      this.props.setHHMMMode(true);

      // ✅ Auto-select HHMM unit if not already selected
      if (this.props.symptomForm.unit !== "445") {
        this.props.onChangeSymptomForm({
          target: { name: "unit", value: "445" }
        });
      }
    }
  }

  render() {
    const {
      t,
      barcode,
      showList,
      classNames,
      categories,
      selectedItem,
      ingredientsModalHandler,
    } = this.props;

    // Display Area Month Translation Helper
    const formatDateTimeLocalized = (date, { includeTime = true } = {}) => {
      const d = moment(date);

      // language: prefer i18next.language; fallback to localStorage; default 'en'
      const lang = (typeof window !== "undefined" && window.localStorage && localStorage.getItem("i18nextLng")) || "en";
      const isEn = String(lang).toLowerCase().startsWith("en");

      // month label: EN → short (MMM); others → full via your translation keys
      const monthEnFull = d.clone().locale("en").format("MMMM").toUpperCase();
      const translatedFullMonth = this.props.t(`meal_plan_summary.${monthEnFull}`);
      const monthLabel = isEn ? d.clone().locale("en").format("MMM") : translatedFullMonth;

      // ⚡ NOTE: Year removed. Time changed to 'hh:mma' (no space before AM/PM)
      let base = `${d.format("DD")} ${monthLabel}`;

      if (includeTime) {
        let timeStr = d.format("hh:mma");
        timeStr = timeStr.replace("am", "a").replace("pm", "p");
        base = `${base} ${timeStr}`;
      }

      return base;
    };

    return (
      <div className="contents">
        <Valert
          display={false}
          title={t("general.CURRENT_ITEM_TITLE")}
          question={t("general.CURRENT_ITEM_TEXT")}
          onRef={(ref) => (this.CurrentItemNotUpdated = ref)}
          positiveAction={this.selectItemPos}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
          negativeAction={() => {
            this.setState({ selectedDetail: {} }); // Forget the temporary Item B
          }}
        />
        <Valert
          display={false}
          title={t("recipe.INCOMPLETE_NEW_ITEM_TITLE")}
          question={t("recipe.INCOMPLETE_NEW_ITEM_TEXT")}
          onRef={(ref) => (this.IncompleteNewItem = ref)}
          positiveAction={this.selectItemPos}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("general.NEW_ITEM_TITLE")}
          question={t("general.NEW_ITEM_TEXT")}
          onRef={(ref) => (this.NewItemNotAdded = ref)}
          positiveAction={this.selectItemPos}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <div
          className={`grayList user-list ${this.state.userValidator && "is-invalid"
            } ${classNames.UsersBox}`}
        >
          {this.props.users.map((item, index) => {
            const isUpdateMode = this.props.updateMode || this.props.cancelMode;
            const checked =
              isUpdateMode && this.props.selectedItem && this.props.selectedItem.users
                ? this.props.selectedItem.users.includes(item._id)
                : item.isSelected;

            const isUserDisabled = this.props.selectedItem && Object.keys(this.props.selectedItem).length > 0;

            return (
              <div className="item" key={index}>
                <label
                  className="symptom-checkbox-container"
                  style={{
                    wordBreak: "break-all",
                    ...(isUserDisabled
                      ? {
                        pointerEvents: "none",
                        opacity: 0.45,
                        cursor: "not-allowed",
                      }
                      : {}),
                  }}
                >
                  <input
                    type="checkbox"
                    disabled={
                      this.props.selectedItem &&
                      Object.keys(this.props.selectedItem).length > 0
                    }
                    checked={checked}
                    onClick={() => this.selectUser(item._id)}
                    readOnly={true}
                  />
                  {`${item.first_name}  ${item.last_name}`}
                  <span
                    className="symptom-checkbox-checkmark"
                    style={{
                      backgroundColor: "#fff"
                    }}
                  />
                </label>
              </div>
            );
          })}
        </div>
        {this.state.userValidator && (
          <div className="invalid-feedback">{this.state.userValidator}</div>
        )}
        <div className={`grayList ingredient-list `} style={{ flex: 1 }}>
          {(!showList || showList.length < 1) && (
            <div className="usersItem">
              <Row style={{ padding: "4px 0 4px 4px" }}>
                <Col>
                  <span className="desc" />
                  {this.props.t("general.INGREDIENTS_EMPTY")}
                </Col>
              </Row>
            </div>
          )}
          {showList &&
            showList.map((item, i) => {
              if (item) {
                let desc = `${item.first_name} ${item.last_name}`;
                var itemsOfList =
                  item.inputs && item.inputs.length > 0
                    ? _.orderBy(item.inputs, ["time"])
                    : undefined;
                return (
                  <div key={item._id}>
                    <h3>{desc}</h3>
                    {itemsOfList &&
                      itemsOfList.map((row, index) => {
                        let sunits = [];
                        if (row.category == "01") {
                          sunits = SYMPTOM_UNITS_NEW();
                        } else if (row.category == "03") {
                          sunits = ACTIVITY_UNITS();
                        } else if (row.category == "04") {
                          sunits = PCP_UNITS();
                        } else if (row.category == "02") {
                          sunits = FOOD_UNITS();
                        } else if (row.category == "05") {
                          sunits = DRUG_UNITS();
                        } else if (row.category == "06") {
                          sunits = SUP_UNITS();
                        } else if (row.category == "07") {
                          sunits = LOC_UNITS();
                        }
                        let unitName = [];
                        for (const sunit of sunits) {
                          if (
                            (sunit._id == row.unit ||
                              sunit._id == row.unitid) &&
                            sunit.unit !== "Unit"
                          ) {
                            unitName = (sunit.displayunit || "").trim();
                          }
                        }
                        let rowText = `$ $ $`;

                        return (
                          <div key={row.vId} className="usersItem">
                            <Row
                              className={
                                "wrapper" + (row.selected ? " selected" : "")
                              }
                              key={i}
                              onClick={() => {
                                if (row.category == "01") {
                                  this.setState({
                                    itemLabel: this.props.t(
                                      "symptoms.ITEM_INPUT_TEXT_SYMPTOM"
                                    ),
                                    scaleLabel: this.props.t(
                                      "general.ITEM_VALUE_TEXT_SYMPTOM"
                                    ),
                                  });
                                } else {
                                  this.setState({
                                    itemLabel: this.props.t(
                                      "general.ITEM_INPUT_TEXT"
                                    ),
                                    scaleLabel: this.props.t(
                                      "general.ITEM_VALUE_TEXT"
                                    ),
                                  });
                                }
                                this.selectItemClick(item, row.vId);
                              }}
                            >

                              <Col className="dateColumn" xs="2 pl-0">
                                {formatDateTimeLocalized(row.time, { includeTime: true })}
                              </Col>

                              <Col className="dateColumn" xs="2">
                                {(row.scale || "").toString().trim()}
                                {unitName ? ` ${unitName}` : ""}
                              </Col>
                              <Col xs="7 pl-0">
                                {row.showName ? row.showName : row.sName}{" "}
                                {row.upc ? `(${row.upc})` : ""}
                              </Col>
                              <Col
                                xs="1"
                                className={
                                  row.ingredients && row.ingredients.length > 0
                                    ? "d-flex justify-content-between"
                                    : "d-flex justify-content-end"
                                }
                                style={{
                                  paddingTop: "4px",
                                }}
                              >
                                {row.ingredients && (
                                  // <i
                                  //   className="fas fa-info-circle deleteIcon ml-0"
                                  //   style={{
                                  //     color: "#007bff",
                                  //   }}
                                  //   onClick={(e) => {
                                  //     e.stopPropagation();
                                  //     ingredientsModalHandler(
                                  //       row.name,
                                  //       row.ingredients
                                  //     );
                                  //   }}
                                  // />

                                  <FontAwesomeIcon
                                    className="fas fa-info-circle deleteIcon ml-0"
                                    icon={faCircleInfo}
                                    style={{
                                      color: "#007bff",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      ingredientsModalHandler(
                                        row.name,
                                        row.ingredients
                                      );
                                    }}
                                  />

                                )}
                                <i
                                  className="far fa-trash-alt deleteIcon"
                                  style={{
                                    marginLeft: "7px",
                                    paddingLeft: "5px",
                                    // color: 'red'
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.props.DeleteIconClicked(row.vId);
                                  }}
                                />
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                  </div>
                );
              }
            })}
        </div>
        <Form>
          <Field component={InputText} type="hidden" name="users" />
          <Field component={InputText} type="hidden" name="symptom" />
          <Field component={InputText} type="hidden" name="type" />
          <FormGroup>
            {/* <Field
              name="category"
              component={Dropdown}
              options={categories}
              disabled={this.props.disabled.category}
              placeholder={this.props.t("symptoms.CATEGORY_TEXT")}
              onClick={this.categoryClicked.bind(this)}
              onChange={this.categoryOnChange}
            /> */}
            <CategoryIconBar
              value={this.props.symptomForm.category}
              disabled={this.props.disabled.category}
              t={t}
              onClick={(newId) => {

                const currentCategory = String((this.props.symptomForm && this.props.symptomForm.category) || "");
                const nextCategory = String(newId || "");

                if (currentCategory === nextCategory) {
                  // same category → no-op
                  return;
                }

                // preserve your existing side effects
                this.categoryClicked();
                this.categoryOnChange({ target: { value: newId } });
              }}
            />



          </FormGroup>
          <FormGroup row>
            <Col>
              <Field
                key={`name-${this.props.symptomForm.category}`}
                name="name"
                component={VautoComplete}
                disabled={this.props.disabled.name}
                placeholder={
                  this.props.symptomForm.category == "01"
                    ? t("symptoms.ITEM_INPUT_TEXT_SYMPTOM")
                    : this.props.symptomForm.category == "02"
                      ? t("general.FOOD_PLACEHOLDER")
                      : this.props.symptomForm.category == "03"
                        ? t("general.ACTIVITY_PLACEHOLDER")
                        : this.props.symptomForm.category == "04"
                          ? t("general.PCP_PLACEHOLDER")
                          : this.props.symptomForm.category == "05"
                            ? t("general.MEDICINE_PLACEHOLDER")
                            : this.props.symptomForm.category == "06"
                              ? t("general.SUPPLEMENT_PLACEHOLDER")
                              : this.props.symptomForm.category == "07"
                                ? t("general.LOCATION_PLACEHOLDER")
                                : t("general.ITEM_INPUT_TEXT")
                }
                onChangeText={(val) => {
                  if (this.state.forceShowHistory) this.setState({ forceShowHistory: false });
                  this.props.searchNameOptions(
                    val,
                    this.props.symptomForm.category,
                    null,
                    this.state.time
                  );
                  if (val) {
                    this.props.setTime(
                      this.props.symptomForm.time
                        ? this.props.symptomForm.time
                        : this.props.time
                          ? this.props.time
                          : moment()
                    );
                  }
                }}
                data={this.props.nameOptions}
                nameTotalOptions={this.props.nameTotalOptions}  // array of objects
                onSelect={this.props.symptomOptionSelected}
                val={this.props.symptomForm.fullname || this.props.symptomForm.name || ""}
                category={this.props.symptomForm.category}
                level="111111001"
                append={this.props.symptomForm.upc}
                onClear={() => {
                  this.props.searchNameOptions("", "", true);
                }}
                showCross={true}
                bodyMapClicked={
                  this.props.symptomForm.category &&
                  this.props.symptomForm.category === "01" &&
                  this.props.bodyMapClicked
                }
                barcodeClicked={
                  this.props.symptomForm.category &&
                    (this.props.symptomForm.category === "02" ||
                      this.props.symptomForm.category === "04" ||
                      this.props.symptomForm.category === "05" ||
                      this.props.symptomForm.category === "06")
                    ? this.props.barcodeClicked
                    : false
                }
                barcodeImageClicked={this.props.barcodeImageClicked}
                barcode={barcode}
                partialResult={this.props.partialResult}
                showPartial={
                  this.state.forceShowHistory
                    ? false
                    : (this.props.partialResult && this.props.partialResult.length > 0)
                }
                barcodeSearch={this.props.barcodeSearch}
                showNoneOfAbove={true}
                showNoneOfAboveText={this.props.t("BARCODE.NONE_OF_ABOVE")}
                addCustomAlert={this.props.addCustomAlert}
                showHistory={this.props.categorySelected}
                onHistoryClick={() => {
                  this.setState({ forceShowHistory: true });
                  this.props.fetchRecentNames();
                }}
                clearHistorySuggestions={this.props.clearHistorySuggestions}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Field
                name="unit"
                component={Dropdown}
                options={this.props.unitOptions}
                placeholder={
                  Array.isArray(this.props.unitOptions) && this.props.unitOptions.length === 1
                    ? ""
                    : this.props.t("symptoms.ITEM_UNIT_TEXT")
                }
                readOnly={this.props.disabled.scale}
                // onClick={this.scaleClicked.bind(this)}
                disabled={this.props.disabled.unit}
                onChange={(e) => this.onChangeSymptomForm(e)}
                val={this.props.symptomForm.unit || ""}
                reseter={this.props.amountReseter}
              />
            </Col>
            <Col>
              {this.props.scaleOptions.length !== 0 ? (
                // 📌 Dropdown when scale options exist
                <Field
                  key={`scale-dropdown-${this.props.amountReseter}`}
                  name="scale"
                  component={Dropdown}
                  options={this.props.scaleOptions}
                  placeholder={
                    this.props.symptomForm.category == "01"
                      ? t("general.ITEM_VALUE_TEXT_SYMPTOM")
                      : t("general.ITEM_VALUE_TEXT")
                  }
                  readOnly={this.props.disabled.scale}
                  disabled={this.props.disabled.scale}
                  onChange={(e) => this.onChangeSymptomForm(e)}
                  amounNewValue={this.props.amounNewValue}
                  reseter={this.props.amountReseter}
                />
              ) : this.props.hhmmMode ? (
                // 🕒 HH:MM entry when semicolon mode is active
                <Field
                  key={`scale-hhmm-${this.props.amountReseter}`}
                  component={InputHHMM}
                  name="scale"
                  placeholder_HH={t("general.ITEM_VALUE_TEXT_HH")}
                  placeholder_MM={t("general.ITEM_VALUE_TEXT_MM")}
                  className="hhmm-styled"
                  disabled={this.props.disabled.scale}
                  onChangeSymptomForm={(e) => this.onChangeSymptomForm(e)}
                  semicolonTriggered={this.props.hhmmMode}
                />
              ) : (
                // 🔢 Default type-in input (fraction or decimal)
                <Field
                  key={`scale-text-${this.props.amountReseter}`}
                  component={InputAmount}
                  name="scale"
                  placeholder={
                    this.props.symptomForm.category == "01"
                      ? t("general.ITEM_VALUE_TEXT_SYMPTOM")
                      : t("general.ITEM_VALUE_TEXT")
                  }
                  onKeyUp={(e) => this.onChangeSymptomForm(e)}
                  onSemiColonTyped={(val) => this.handleSemiColonInAmount(val)}  // Hadles "HH:MM"
                  amounNewValue={this.props.amounNewValue}
                  reseter={this.props.amountReseter}
                  mode="allowfraction"
                  className={`${this.state.scaleValidator && "is-invalid"}`}
                  disabled={this.props.disabled.scale}
                  HHMM_Allowed={this.props.unitOptions.some((opt) => opt.value === "445")}
                />
              )}
            </Col>
          </FormGroup>

          <FormGroup>
            <DateTimePicker
              placeholder={
                this.props.symptomForm &&
                  (this.props.symptomForm.category == "03" ||
                    this.props.symptomForm.category == "02")
                  ? t("symptoms.CALENDER_ACTIVITY_TEXT")
                  : this.props.symptomForm &&
                    this.props.symptomForm.category == "07"
                    ? t("symptoms.CALENDER_LOCATION_TEXT")
                    : this.props.t("symptoms.TIME_TEXT")
              }
              value={
                this.props.symptomForm.time
                  ? this.props.symptomForm.time
                  : this.props.time
                    ? this.props.time
                    : ""
              }
              currentValue={this.props.symptomForm.time}
              onChange={(e) => {
                this.props.onDateChange(e); // handles SYMPTOM_DATE_CHANGED (time assignment)
                this.props.setTime(e); // handles visual state change in calendar
                this.onChangeSymptomForm({
                  target: { name: "time", value: e }
                });  // triggers ON_CHANGE_SYMPTOMFORM to update itemChanged logic
              }}
              dateFormat="DD MMM YYYY, hh:mm A"
              disabled={this.props.disabled.time}
              disableFutureDates={true}
              showLabel={true}
            />
          </FormGroup>
          <FormGroup>
            <Field
              name="comment"
              component={InputText}
              type="textarea"
              placeholder={this.props.t("products.COMMENT_DEFAULT_TEXT")}
              disabled={this.props.disabled.comment || ""}
              onChange={(e) => this.onChangeSymptomForm(e)}
              maxLength={5000}
            />
          </FormGroup>
        </Form>
      </div>
    );
  }
}

SymptomForm = reduxForm({
  form: "formSymptom",
  enableReinitialize: true,
})(SymptomForm);

SymptomForm = connect((state) => ({
  initialValues: state.symptom.symptomForm,
}))(SymptomForm);

class Symptom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDuplicateError: false,
      posunits: undefined,
      ingredientsVmodal: false,
      ingredientsVmodalData: [],
      clearSelectedId: "",
      deleteNotUpdated: false,
      deleteNotAdded: false,
      barcode: "",
      updateMode: false,
      appendBarcode: "",
      itemDetails: {},
      kitdata: false,
      noSaveAlert: false,
      barcodeAlert: false,
      barcodeValue: this.props.barcodeValue,
      time: "",
      compressingCount: 0,
      showTrendAfterSuccess: false,
    };

    this.AddItemClicked = this.AddItemClicked.bind(this);
    this.addKitClicked = this.addKitClicked.bind(this);
    this.SavePageClicked = this.SavePageClicked.bind(this);
    this.UpdateItemClicked = this.UpdateItemClicked.bind(this);
    this.ClearPageClicked = this.ClearPageClicked.bind(this);
    this.clearSymptom = this.clearSymptom.bind(this);
    this.submitAfterAsk = this.submitAfterAsk.bind(this);
    this.ingredientsModalHandler = this.ingredientsModalHandler.bind(this);
    this.DeleteIconClicked = this.DeleteIconClicked.bind(this);
    this.inputFileRef = React.createRef();
    this.addCustomAlert = this.addCustomAlert.bind(this);
    this.setTime = this.setTime.bind(this);
    this.clearTime = this.clearTime.bind(this);
  }

  componentWillUnmount() {
    if (this.cleanupPage) this.cleanupPage();
  }

  componentDidMount() {
    // ✅ Call helper that handles Contribution Cancelled for Chrome, Firefox, Safari & Edge
    // Product Not Contributed prompt display and recreate unsavedAlertData 
    this.cleanupPage = SetupPageWithBFCacheAndPrompt(this, {
      promptRefName: "ProductNotContributed",
      initCallback: () => {
        if (!isLoggedIn()) {
          this.props.history.push("/");
          return;
        }
        this.loggedInUser = getLoggedInUser();
        this.props.inputPageInitialization(this.loggedInUser._id);
      },

      // NEW: make sure we’re reading the latest storage on restores
      dirtyFlagKey: "previousPageIsDirty",
      onDirtyFlagChange: (exists) => {
        // Optional: if your page keeps any local state/Redux that depends on this flag,
        // clear it here when exists === false.
        // (Most pages don’t need anything here; the normalize step is enough.)
      },
    });

    const selectedVId = sessionStorage.getItem("selectedVId");
    if (selectedVId) {
      this.selectedVId = selectedVId;
      sessionStorage.removeItem("selectedVId"); // Cleanup
    }
  }

  bodyMapClicked() {
    let showList = this.props.showList || [];
    let symptomFormData = {
      ...this.props.symptomForm,
    };
    localStorage.setItem("showList", JSON.stringify(showList));
    localStorage.setItem("symptomForm", JSON.stringify(symptomFormData));
    localStorage.setItem("bodyreturn", "symptom");
    if (!this.props.disabled.saveBtn) {
      sessionStorage.setItem("previousPageIsDirty", "input"); // Set previousPageIsDirty if Save Page button is enabled
    }

    if (this.selectedVId) {
      sessionStorage.setItem("selectedVId", this.selectedVId); // Store selectedVId to be retrieved after returning to Input Page
    }
    window.location.href = "/bodymap";
  }

  ingredientsModalHandler(title, ingredients_text) {
    let returnHTml = (
      <div className="ingredientsAreaInMealPlanner">
        <h4>{title}</h4>
        <ul>
          <span style={{ fontWeight: 500 }}>
            {this.props.t("symptoms.INGREDIENT_TEXT")}
          </span>
          <span style={{ fontSize: 14, color: "#333" }}>
            {ingredients_text}
          </span>
        </ul>
      </div>
    );

    this.setState({
      ingredientsVmodal: true,
      ingredientsVmodalData: returnHTml,
    });
  }

  clearSymptom(action) {
    this.selectedVId = null;
    this.symptomFormRef.clearSymptom(); // Clear selected item and VId after successful Clear Page
    this.setState({
      updateMode: false,
      kitdata: false,
      time: "",
    });
  }

  addKitClicked() {
    this.props.addKitClicked();
  }

  SavePageClicked() {
    const formItem = this.props.symptomForm;
    const selectedItem = this.props.selectedItem;
    const selectedVId = this.selectedVId;

    const isSelected = !!selectedVId;

    const formChanged =
      isSelected &&
      (
        this.props.itemChanged ||
        (formItem && selectedItem && formItem.name !== selectedItem.name) ||
        (formItem && selectedItem && formItem.category !== selectedItem.category)
      );

    const formHasNameOrUPC =
      formItem &&
      (
        (formItem.name && formItem.name.trim() !== "") ||
        (formItem.upc && formItem.upc.trim() !== "")
      );

    const isNewItem = !isSelected && formHasNameOrUPC;

    // Case 1: User makes changes to a selected item (Update Item enabled) and tries to Save Page → Selected Item not Updated
    if (isSelected && formChanged && !this.props.cancelMode) {
      this.SelectedItemNotUpdated.changeStatus();
    }
    // Case 2: User makes changes to a selected item (Cancel Update enabled) and tries to Save Page → Incomplete Change to Selected Item
    else if (isSelected && formChanged && this.props.cancelMode) {
      this.IncompleteChangeToSelectedItem.changeStatus();
    }
    // Case 3: User filling form for new item (Add Item enabled) and tries to Save Page → Last Item not Added
    else if (isNewItem && !this.props.disabled.addBtn) {
      this.LastItemNotAdded.changeStatus();
    }
    // Case 4: User filling form for new item (Add Item disabled) and tries to Save Page → Incomplete Last Item
    else if (isNewItem && this.props.disabled.addBtn) {
      this.IncompleteLastItem.changeStatus();
    }
    else {
      this.props.saveClicked(prepareForBackend(this.props.showList));
      this.symptomFormRef.selectItemPos(); // ✅ Clear selected item and VId after successful save
    }
  }

  submitAfterAsk(values) {
    this.props.saveClicked(prepareForBackend(this.props.showList));
    this.symptomFormRef.selectItemPos(); // ✅ Clear selected item and VId after successful save
  }

  // Method to get the VId of the currently selected item from SymptomForm to Symptom Class
  onVIdSelected = (vId) => {
    this.selectedVId = vId;
  };

  timeDiff(values, item) {
    const newTime = {
      currentTime: values.time.valueOf(),
      nextTime: item.time.valueOf() + 300000,
      pastTime: item.time.valueOf() - 300000,
    };
    return newTime;
  }

  posunits(unit, cat) {
    let units = {};
    units.names = "";
    units.ids = [];
    let lsUnits = [];
    if (cat == "01") {
      lsUnits = SYMPTOM_UNITS_NEW();
    } else if (cat == "03") {
      lsUnits = ACTIVITY_UNITS();
    } else if (cat == "04") {
      lsUnits = PCP_UNITS();
    } else if (cat == "02") {
      lsUnits = FOOD_UNITS();
    } else if (cat == "05") {
      lsUnits = DRUG_UNITS();
    } else if (cat == "06") {
      lsUnits = SUP_UNITS();
    } else if (cat == "07") {
      lsUnits = LOC_UNITS();
    }
    if (cat === "02") {
      lsUnits.map((item) => {
        if (unit !== "135" && unit !== "125") {
          if (item._id !== "135" && item._id !== "125") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else {
          if (item._id === unit) {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        }
      });
    } else if (cat === "03") {
      lsUnits.map((item) => {
        if (unit === "101" || unit === "102" || unit === "445") {
          if (item._id === "101" || item._id === "102" || item._id === "445") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else if (unit === "103" || unit === "104") {
          if (item._id === "103" || item._id === "104") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else {
          if (item._id === unit) {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        }
      });
    } else {
      lsUnits.map((item) => {
        if (item._id === unit) {
          units.names += item.unit + ", ";
          units.ids.push(item._id);
        }
      });
    }
    units.names = units.names.slice(0, -2);
    return units;
  }

  DeleteIconClicked(id) {
    this.deleteId = id;

    const formItem = this.props.symptomForm;
    const selectedItem = this.props.selectedItem;
    const selectedVId = this.selectedVId;

    const isSelected = !!selectedVId;
    const isSameItem = selectedVId === id;

    const formChanged =
      isSelected &&
      (
        this.props.itemChanged ||
        (formItem && selectedItem && formItem.name !== selectedItem.name) ||
        (formItem && selectedItem && formItem.category !== selectedItem.category)
      );

    const formHasNameOrUPC =
      formItem &&
      (
        (formItem.name && formItem.name.trim() !== "") ||
        (formItem.upc && formItem.upc.trim() !== "")
      );

    const isNewItem = !isSelected && formHasNameOrUPC;

    // Case 1: User editing selected item and tries to delete a different item → deleteNotUpdated
    if (isSelected && formChanged && !isSameItem) {
      this.setState({
        deleteNotUpdated: true,
        deleteNotAdded: false,
      });
    }
    // Case 2: User filling form for new item, but tries to delete an item from Display Area → deleteNotAdded
    else if (isNewItem) {
      this.setState({
        deleteNotUpdated: false,
        deleteNotAdded: true,
      });
    }
    // Case 3: Otherwise → show normal delete confirmation
    else {
      this.setState({
        deleteNotUpdated: false,
        deleteNotAdded: false,
      });
    }

    this.deleteValert.changeStatus();

  }

  AddItemClicked() {
    this.selectedVId = null;
    this.setState({
      updateMode: false,
      showDuplicateError: false,
    });

    var values = this.props.symptomForm;

    const isCustomEntry = !values.symptom && !values.upc;
    const cleanedNewName = values.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim();

    // Check if the name is already in Display Area for the same category 
    const isAlreadyInDisplay = this.props.showList.some(user =>
      (user.inputs || []).some(inputItem =>
        !inputItem.symptom && !inputItem.upc &&                       // ✅ Only compare with other custom items
        inputItem.name &&
        inputItem.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim() === cleanedNewName &&
        String(inputItem.category) === String(values.category)        // ✅ Only compare withing same category
      )
    );

    // Determine whether to show "Item not in 12u12 Database" prompt or not
    const shouldShowNoIdPrompt = isCustomEntry && !isAlreadyInDisplay;

    const addCustomItemToDisplay = () => {
      const updatedName = values.name.replace(/\s+/g, " ").trim(); // Adding "(C)" is handled in reducer
      values.name = updatedName;
      values.showName = updatedName;
      values.displayName = updatedName;

      const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
      values.backendScale = conversionresult.scale;
      values.backendUnit = conversionresult.unit;

      this.props.addItem(values);
    };

    // 🔁 Check for regimen-based duplicate (no selectedVId to exclude)
    const kitItems =
      (values.kitdata && values.kitdata.length > 0)
        ? values.kitdata
        : (this.props.symptomForm && this.props.symptomForm.kitdata) || [];

    if (kitItems.length > 0) {
      const kitSymptomIds = kitItems.map((item) => item.symptom);
      const selectedTime = values.time.valueOf();
      let isDuplicateFound = false;

      values.users.forEach((inputUser) => {
        this.props.showList.forEach((user) => {
          if (user._id === inputUser && user.inputs && user.inputs.length > 0) {
            user.inputs.forEach((inputItem) => {
              if (
                inputItem.category === values.category &&  //✅ Must match category
                inputItem.symptom && // Making sure ID exists
                kitSymptomIds.includes(inputItem.symptom) // Matches by ID because all contents of regimen has ID
              ) {
                const diffMs = Math.abs(selectedTime - inputItem.time.valueOf());
                if (diffMs <= 5 * 60 * 1000) {
                  isDuplicateFound = true;
                }
              }
            });
          }
        });
      });

      if (isDuplicateFound) {
        this.setState({ showDuplicateError: false }, () => {
          this.setState({ showDuplicateError: true, kitdata: true });
          // 🚫 No need to do outOfRange check for regimen
          this.pendingRangeCheck = () => false;
        });
        return;
      } else {
        this.props.addKitClicked();
        return;
      }
    }

    // 🔁 Check for individual item duplicate
    const selectedTime = values.time.valueOf();
    let isDuplicateFound = false;
    let selectedKey = values.symptom || values.upc || values.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim(); //If ID present, use ID for comparison. Otherwise, use UPC. And use name as the last option if both ID and UPC are not present
    let selectedKeyType = values.symptom ? 'symptom' : (values.upc ? 'upc' : 'name');

    // 🔐 Early exit on incompatible unit check
    if (this.checkIncompatibleUnit(selectedKeyType, selectedKey, values)) {
      return;
    }

    // Determine if the amount field is a dropdown
    const isDropdownAmount =
      Array.isArray(this.props.scaleOptions) && // Check if scaleOptions is an array
      this.props.scaleOptions.some(
        (opt) => String(opt.value) === String(this.props.symptomForm.scale) // Make sure the value in Amount field is same as one of the scaleOptions
      );

    // If amount field is a dropdown, skip "Invalid Amount" check
    const amountValue = isDropdownAmount
      ? this.props.symptomForm.scale
      : checkInput(this.props.symptomForm.scale, this.props.symptomForm.unit);

    if (!amountValue) {
      this.invalidValue.changeStatus(); // trigger Invalid Value prompt when criteria for valid value is not met
      return;
    }

    values.users.forEach((inputUser) => {
      this.props.showList.forEach((user) => {
        if (user._id === inputUser && user.inputs && user.inputs.length > 0) {
          user.inputs.forEach((inputItem) => {
            const itemTime = inputItem.time.valueOf();
            const diffMs = Math.abs(selectedTime - itemTime);

            // Determine key to be used for duplicate comparison for item in Display Area
            //If ID present, use ID for comparison. Otherwise, use UPC. And use name as the last option if both ID and UPC are not present. For name comparison, temporarily remove "(C)" from the name in Display Area before comparing with the name in the item name field
            let itemKey = inputItem.symptom || inputItem.upc || (inputItem.name && inputItem.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim());

            // ✅ Duplicate entry match
            if (
              inputItem.category === values.category && // ✅ Must match category
              itemKey === selectedKey &&// Matches by ID/upc/name
              diffMs <= 5 * 60 * 1000 // Within 5 minutes
            ) {
              isDuplicateFound = true;
            }
          });
        }
      });
    });

    if (isDuplicateFound) {
      this.setState({ showDuplicateError: false }, () => {
        this.setState({ showDuplicateError: true });
        this.pendingRangeCheckSource = "from duplicate prompt";
        this.pendingRangeCheck = () => {
          if (this.props.outOfRange && this.rangeCheck) {
            this.rangeCheck.changeStatus();
            this.pendingCustomCheck = () => {
              if (shouldShowNoIdPrompt) {
                addCustomItemToDisplay();
              } else {
                const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
                values.backendScale = conversionresult.scale;
                values.backendUnit = conversionresult.unit;
                this.props.addItem(this.props.symptomForm);
              }
              return true;
            };
            return true;
          }

          // ✅ No out of range, handle final step directly
          if (shouldShowNoIdPrompt) {
            addCustomItemToDisplay();
          } else {
            const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
            values.backendScale = conversionresult.scale;
            values.backendUnit = conversionresult.unit;
            this.props.addItem(this.props.symptomForm);
          }
          return true;
        };
      });
      return;
    }

    // 🔁 Handle value too small / too large case — conditionally add (C)
    if (this.props.outOfRange && this.rangeCheck) {
      this.rangeCheck.changeStatus();
      this.pendingCustomCheck = () => {
        if (isCustomEntry && shouldShowNoIdPrompt && this.CustomItemNotIn12u12DB) {
          this.CustomItemNotIn12u12DB.changeStatus(values);
          this.pendingCustomCheck = () => {
            addCustomItemToDisplay();
            return true;
          };
          return true;
        }
        // ✅ If it's a new custom item → Add (C)
        if (shouldShowNoIdPrompt) {
          addCustomItemToDisplay();
          return true;
        }
        // ✅ Else just update as-is (no (C))
        const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
        values.backendScale = conversionresult.scale;
        values.backendUnit = conversionresult.unit;
        this.props.addItem(this.props.symptomForm);
        return true;
      };
      return;
    }

    // 🔁 If only item not in 12u12 database
    if (shouldShowNoIdPrompt && this.CustomItemNotIn12u12DB) {
      this.CustomItemNotIn12u12DB.changeStatus(values);
      this.pendingCustomCheck = () => {
        addCustomItemToDisplay();
        return true;
      };
      return;
    }

    // 🔁 Fallback if no duplication or value issues
    if (shouldShowNoIdPrompt) {
      addCustomItemToDisplay();
    } else {
      const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
      values.backendScale = conversionresult.scale;
      values.backendUnit = conversionresult.unit;
      this.props.addItem(this.props.symptomForm);
    }
  }

  UpdateItemClicked() {
    this.setState({
      updateMode: true,
      showDuplicateError: false,
    });

    var values = this.props.symptomForm;
    const originalItem = this.props.selectedItem;

    const cleanedNewName = values.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim();
    const cleanedOriginalName = originalItem.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim();

    const hasCategoryChanged = values.category !== originalItem.category;

    let hasNameChanged;
    if (originalItem.id) {
      hasNameChanged = !values.symptom || originalItem.id !== values.symptom;
    } else if (originalItem.upc) {
      hasNameChanged = !values.upc || originalItem.upc !== values.upc;
    } else {
      hasNameChanged = cleanedNewName !== cleanedOriginalName;
    }

    const hasNameOrCategoryChanged = hasNameChanged || hasCategoryChanged;
    const hasTimeChanged = values.time.valueOf() !== originalItem.time.valueOf();

    const isCustomEntry = !values.symptom && !values.upc;


    // Check if the name is already in Display Area for the same category 
    const isAlreadyInDisplay = this.props.showList.some(user =>
      (user.inputs || []).some(inputItem =>
        inputItem.vId !== this.selectedVId &&                         // ✅ Exclude self
        !inputItem.symptom && !inputItem.upc &&                       // ✅ Only compare with other custom items
        inputItem.name &&
        inputItem.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim() === cleanedNewName &&
        String(inputItem.category) === String(values.category)        // ✅ Only compare withing same category 
      )
    );

    // Determine whether to show "Item not in 12u12 Database" prompt or not
    const shouldShowNoIdPrompt = isCustomEntry && hasNameOrCategoryChanged && !isAlreadyInDisplay;

    // Determine whether to check for duplicate entries
    const shouldCheckDuplicate = (hasNameOrCategoryChanged || hasTimeChanged);

    const addCustomItemToDisplay = () => {
      const updatedName = values.name.replace(/\s+/g, " ").trim(); // Adding "(C)" is handled in reducer
      values.name = updatedName;
      values.showName = updatedName;
      values.displayName = updatedName;

      const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
      values.backendScale = conversionresult.scale;
      values.backendUnit = conversionresult.unit;

      this.props.updateItem(updatedName);
      this.setState({ updateMode: false });
      this.selectedVId = null; // ✅ Clear selected item and VId after successful update
    };

    const kitItems =
      (values.kitdata && values.kitdata.length > 0)
        ? values.kitdata
        : (this.props.symptomForm && this.props.symptomForm.kitdata) || [];

    // 🔁 Check for regimen-based duplicate (no custom logic needed)
    if (kitItems.length > 0 && shouldCheckDuplicate) {
      const kitSymptomIds = kitItems.map((item) => item.symptom);
      const selectedTime = values.time.valueOf();
      let isDuplicateFound = false;

      values.users.forEach((inputUser) => {
        this.props.showList.forEach((user) => {
          if (user._id === inputUser && user.inputs && user.inputs.length > 0) {
            user.inputs.forEach((inputItem) => {
              if (
                inputItem.vId !== this.selectedVId && // Exclude the currently selected item from comparison
                inputItem.category === values.category && // ✅ Must match category
                inputItem.symptom && // Making sure ID exists
                kitSymptomIds.includes(inputItem.symptom) // Matches by ID because all contents of regimen has ID
              ) {
                const diffMs = Math.abs(selectedTime - inputItem.time.valueOf());
                if (diffMs <= 5 * 60 * 1000) {
                  isDuplicateFound = true;
                }
              }
            });
          }
        });
      });

      if (isDuplicateFound) {
        this.setState({ showDuplicateError: false }, () => {
          this.setState({ showDuplicateError: true, kitdata: true });
          // 🚫 No need to do outOfRange check here for regimen
          this.pendingRangeCheck = () => false;
        });
        return;
      } else {
        this.props.addKitClicked();
        this.selectedVId = null; // ✅ Clear selected item and VId after successful update
        return;
      }
    }

    // Determine comparison type and selectedKey (item to be updated)
    let selectedKey = values.symptom || values.upc || values.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim(); //If ID present, use ID for comparison. Otherwise, use UPC. And use name as the last option if both ID and UPC are not present
    let selectedKeyType = values.symptom ? 'symptom' : (values.upc ? 'upc' : 'name');

    // 🔐 Incompatible Unit check
    if (this.checkIncompatibleUnit(selectedKeyType, selectedKey, values)) {
      return;
    }

    // Determine if the amount field is a dropdown
    const isDropdownAmount =
      Array.isArray(this.props.scaleOptions) && // Check if scaleOptions is an array
      this.props.scaleOptions.some(
        (opt) => String(opt.value) === String(this.props.symptomForm.scale) // Make sure the value in Amount field is same as one of the scaleOptions
      );

    // If amount field is a dropdown, skip "Invalid Amount" check
    const amountValue = isDropdownAmount
      ? this.props.symptomForm.scale
      : checkInput(this.props.symptomForm.scale, this.props.symptomForm.unit);

    if (!amountValue) {
      this.invalidValue.changeStatus(); // trigger Invalid Valud prompt when criteria for valid value is not met
      return;
    }

    // 🔁 Check for individual item duplicate (based on id, upc, or name)
    if (shouldCheckDuplicate) {
      const selectedTime = values.time.valueOf();
      let isDuplicateFound = false;

      values.users.forEach((inputUser) => {
        this.props.showList.forEach((user) => {
          if (user._id === inputUser && user.inputs && user.inputs.length > 0) {
            user.inputs.forEach((inputItem) => {
              const itemTime = inputItem.time.valueOf();
              const diffMs = Math.abs(selectedTime - itemTime);

              // Determine key to be used for duplicate comparison for item in Display Area
              // If ID present, use ID for comparison. Otherwise, use UPC. And use name as the last option if both ID and UPC are not present. For name comparison, temporarily remove "(C)" from the name in Display Area before comparing with the name in the item name field
              let itemKey = inputItem.symptom || inputItem.upc || (inputItem.name && inputItem.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim());

              // Exclude currently selected item from comparison using vId
              // Compare the vId of items in Display Area with the vId of currently selected item (tmporarily stored when user click on it). If identical, exclude from comparison
              // const isSameItem = inputItem.vId === this.selectedVId;
              const isSameItem = this.selectedVId && inputItem.vId
                ? inputItem.vId === this.selectedVId
                : false;

              // ✅ Duplicate entry match
              if (
                !isSameItem && // Exclude the currently selected item from comparison
                inputItem.category === values.category && // ✅ Must match category
                itemKey === selectedKey && // Matches by ID/upc/name
                diffMs <= 5 * 60 * 1000 // Within 5 minutes
              ) {
                isDuplicateFound = true;
              }
            });
          }
        });
      });


      if (isDuplicateFound) {
        this.setState({ showDuplicateError: false }, () => {
          this.setState({ showDuplicateError: true, updateMode: true });
          this.pendingRangeCheckSource = "from duplicate prompt";
          this.pendingRangeCheck = () => {
            if (this.props.outOfRange && this.rangeCheck) {
              this.rangeCheck.changeStatus();
              this.pendingCustomCheck = () => {
                if (shouldShowNoIdPrompt) {
                  addCustomItemToDisplay();
                } else {
                  const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
                  values.backendScale = conversionresult.scale;
                  values.backendUnit = conversionresult.unit;
                  this.props.updateItem(this.props.symptomForm.showName);
                  this.setState({ updateMode: false });
                  this.selectedVId = null; // ✅ Clear selected item and VId after successful update
                }
                this.selectedVId = null; // ✅ Clear selected item and VId after successful update
                return true;
              };
              return true;
            }
            // ✅ No out of range, handle final step directly
            if (shouldShowNoIdPrompt) {
              addCustomItemToDisplay();
            } else {
              const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
              values.backendScale = conversionresult.scale;
              values.backendUnit = conversionresult.unit;
              this.props.updateItem(this.props.symptomForm.showName);
              this.setState({ updateMode: false });
              this.selectedVId = null; // ✅ Clear selected item and VId after successful update
            }
            this.selectedVId = null; // ✅ Clear selected item and VId after successful update
            return true;
          };
        });
        return;
      }
    }

    // 🔁 Handle value too small / too large case — conditionally add (C)
    if (this.props.outOfRange && this.rangeCheck) {
      this.rangeCheck.changeStatus();
      this.pendingCustomCheck = () => {
        if (shouldShowNoIdPrompt && this.CustomItemNotIn12u12DB) {
          this.CustomItemNotIn12u12DB.changeStatus();
          this.pendingCustomCheck = () => {
            addCustomItemToDisplay();
            this.selectedVId = null; // ✅ Clear selected item and VId after successful update
            return true;
          };
          return true;
        }

        // ✅ If it's a new custom item and name changed → Add (C)
        if (shouldShowNoIdPrompt) {
          addCustomItemToDisplay();
          this.selectedVId = null; // ✅ Clear selected item and VId after successful update
          return true;
        }

        // ✅ Else just update as-is (no (C))
        const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
        values.backendScale = conversionresult.scale;
        values.backendUnit = conversionresult.unit;
        this.props.updateItem(this.props.symptomForm.showName);
        this.setState({ updateMode: false });
        this.selectedVId = null; // ✅ Clear selected item and VId after successful update
        return true;
      };

      return;
    }

    // 🔁 If only item not in 12u12 database
    if (shouldShowNoIdPrompt && this.CustomItemNotIn12u12DB) {
      this.CustomItemNotIn12u12DB.changeStatus();
      this.pendingCustomCheck = () => {
        addCustomItemToDisplay();
        this.selectedVId = null; // ✅ Clear selected item and VId after successful update
        return true;
      };
      return;
    }

    // 🔁 Fallback if no duplication or value issues
    if (shouldShowNoIdPrompt) {
      addCustomItemToDisplay();
    } else {
      const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
      values.backendScale = conversionresult.scale;
      values.backendUnit = conversionresult.unit;
      this.props.updateItem(this.props.symptomForm.showName);
      this.setState({ updateMode: false });
      this.selectedVId = null; // ✅ Clear selected item and VId after successful update
    }
  }

  ClearPageClicked() {
    this.ClearConfirmation.changeStatus();
  }

  barcodeAlert = () => {
    this.barcodeAlertStatus.changeStatus();
  };

  barcodeImageClicked() {
    this.inputFileRef.current.click();
  }

  onBarcodeSearch = () => {
    this.props.barcodeSearch(
      this.state.barcode,
      this.props.symptomForm.category
    );
    this.setState({ barcodeValue: this.state.barcode });
    this.setState({ barcode: "" });
  };

  async submitUpcImage(image) {
    if (!image) return;

    this.startCompress();
    let fileToSend = image;
    try {
      // fileToSend = image.size > 1000000 ? await compressImageSmart(image) : image;

      // 1) Only compress when > 1MB (your existing helper)
      if (fileToSend.size > 1000000) {
        fileToSend = await compressImageSmart(fileToSend);
      }

      // 2) Always sanitize-encode (avoid WAF/ALB false positives)
      fileToSend = await sanitizeEncodeImage(fileToSend, {
        mimeType: "image/jpeg",
        quality: 0.88,  // or 0.90 if you prefer, but 0.88 is safer
        maxDim: 2048,
      });

      console.log("[upload] final", fileToSend.type, fileToSend.size, fileToSend.name);

    } finally {
      this.endCompress();
    }

    this.props.onSubmitUpcImage(fileToSend, this.props.symptomForm.category);
  }

  startCompress = () =>
    this.setState(s => ({
      compressingCount: s.compressingCount + 1
    }));

  endCompress = () =>
    this.setState(s => {
      const next = Math.max(0, s.compressingCount - 1);
      return { compressingCount: next };
    });

  addKitPromptClicked() {
    this.props.addKitClicked();
    this.setState({
      kitdata: false,
    });
  }

  // 🔁 Helper Function: Check for incompatible measurement unit (can be applied for Add and Update Item)
  checkIncompatibleUnit(selectedKeyType, selectedKey, values) {
    if (!values || !values.users || !Array.isArray(values.users)) return false;

    const category = values.category;
    const selectedUnit = values.unit;

    // ✅ Skip incompatible measurement unit check if Category is Symptom (01) or Location (07)
    if (category === "01" || category === "07") return false;

    // ✅ For Food (02) and Activity (03) categories, only perform incompatible measurement unit check if selectedKey is UPC or Name (not ID)
    if ((category === "02" || category === "03") && selectedKeyType === "symptom") return false;

    let isIncompatible = false;

    this.props.showList.forEach((user) => {
      if (Array.isArray(user.inputs) && user.inputs.length > 0) {
        user.inputs.forEach((inputItem) => {
          // detect and exclude currently selected item from comparison
          const isSameItem = this.selectedVId && inputItem.vId
            ? inputItem.vId === this.selectedVId
            : false;

          // Determine key to be used for duplicate comparison for item in Display Area
          //If ID present, use ID for comparison. Otherwise, use UPC. And use name as the last option if both ID and UPC are not present. For name comparison, temporarily remove "(C)" from the name in Display Area before comparing with the name in the item name field
          const itemKey = inputItem.symptom || inputItem.upc || (inputItem.name && inputItem.name.replace(/\s+/g, " ").trim().toLowerCase().replace(/\(c\)$/i, "").trim());

          // ✅ If keys match excluding the currently selected item, check unit group compatibility
          if (itemKey === selectedKey && !isSameItem && inputItem.category === category) {
            const allowedUnitsObj = this.posunits(inputItem.unit, inputItem.category);
            const allowedUnitIds = (allowedUnitsObj && allowedUnitsObj.ids) ? allowedUnitsObj.ids : [];
            const allowedUnitNames = (allowedUnitsObj && allowedUnitsObj.names) ? allowedUnitsObj.names : "N/A";

            const isCompatible = allowedUnitIds.includes(selectedUnit);

            if (!isCompatible) {
              this.setState({
                posunits: allowedUnitNames,  // use string directly for prompt text
              });
              this.showDuplicateUnit.changeStatus(); // 🚨 Show VAlert
              isIncompatible = true;
            }
          }
        });
      }
    });
    return isIncompatible;
  }

  addBarcodeToField() {
    this.setState({
      appendBarcode: this.props.upc404,
    });
    let contDefault = {
      page: "symptom",
      barcode: this.props.upc404Value || this.props.symptomForm.upc,
      category: this.props.symptomForm.category,
      userList: this.props.users,
      users: this.props.symptomForm.users,
      showList: this.props.showList,
      time: this.props.symptomForm.time,
      comment: this.props.symptomForm.comment,
      name: this.props.symptomForm.name,
      sName: this.props.symptomForm.sName,
      unitList: this.props.symptomForm.unitList || [],
      unit: this.props.symptomForm.unit,
      scale: this.props.symptomForm.scale,
    };
    let defaultVal = JSON.stringify(contDefault);
    localStorage.setItem("contDefault", defaultVal);
  }

  addCustomAlert() {
    this.props.searchNameOptions("", "", true);
    this.addCustomVAlert.changeStatus();
  }

  handleContributePrompt(action) {
    this.props.handleContributePrompt(action);
  }

  addGreyUPC = () => {
    let contDefault = JSON.parse(localStorage.getItem("contDefault"));
    if (contDefault && contDefault.barcode) {
      this.props.addGreyUPCToItemNameField(contDefault.barcode);
      this.props.searchNameOptions("", "", false, true); // Do not clear UPC
      localStorage.removeItem("contDefault"); // ✅ Clear after clicking Continue button
      localStorage.removeItem("unContributed");
    }
  };

  clearTime() {
    this.setState({ time: "" });
  }
  setTime(time) {
    this.setState({ time });
  }

  render() {
    let {
      t,
      disabled,
      classNames,
      onChangeSymptomForm,
      amounNewValue,
      selectItem,
      selectedList,
      updateMode,
      cancelMode,
      categories,
      isLoading,
      alreadyUsedRecipeName,
    } = this.props;
    return (
      <div className="vPage symptom flex symptom-modern">
        {/*Show loading icon whenever Redux is loading OR we’re compressing:*/}
        <Loading isLoading={isLoading || this.state.compressingCount > 0} />
        <input
          style={{ display: "none" }}
          type="file"
          name="file"
          id="upc-img"
          ref={this.inputFileRef}
          accept="image/*"
          multiple={false}
          onChange={(e) => {
            e.preventDefault();
            e.target.files && e.target.files.length > 0
              ? this.submitUpcImage(e.target.files[0])
              : null;
          }}
          onClick={(e) => (e.target.value = null)}
        />
        <Vmodal
          zIndex={15}
          displayStatus={this.state.ingredientsVmodal}
          data={this.state.ingredientsVmodalData}
          closeFunc={() => {
            this.setState({
              ingredientsVmodal: false,
              ingredientsVmodalData: "",
            });
          }}
        />
        <Vmodal
          displayStatus={this.props.saveSuccess}
          data={
            <div>
              <h4>{t("general.SAVE_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("meal_planner.SAVE_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            if (this.props.NewTrendFound) {
              // 1) Hide success modal (unbind displayStatus)
              this.props.dismissSaveSuccess();
              // 2) Then show Trend Alert
              this.setState({ showTrendAfterSuccess: true });
            } else {
              this.props.clearSymptom();
              window.location.reload();
            }
          }}
          timedClose={2000}
        />
        <Valert
          display={this.state.showTrendAfterSuccess}
          title={t("general.TREND_ALERT_TITLE")}
          question={t("general.TREND_ALERT_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            // After acknowledging Trend Alert, finish the flow
            this.props.clearSymptom();
            window.location.reload();
          }}
          readOnly={true}
        />
        <Valert
          display={this.props.itemInVerAutofill}
          onRef={(ref) => (this.itemInVerAutofillRef = ref)}
          title={t("symptoms.ITEM_IN_VERIFICATION_TITLE")}
          question={t("symptoms.ITEM_IN_VERIFICATION_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.symptomOptionSelected(this.props.itemData);

            this.props.onChangeAlertStatus({
              itemInVerAutofill: false,
            });
          }}
          readOnly={true}
        />
        <Valert
          display={false}
          title={t("general.ENTER_BARCODE")}
          onRef={(ref) => (this.barcodeAlertStatus = ref)}
          inputField={true}
          inputType={"number"}
          showInvalid={false}
          positiveAction={this.onBarcodeSearch}
          inputValue={this.state.barcode}
          onChangeInput={(e) => this.setState({ barcode: e.target.value })}
          positiveText={t("general.SUBMIT")}
          negativeText={t("general.CANCEL")}
          negativeAction={() => this.setState({ barcode: "" })}
          okBtn={
            this.state.barcode && this.state.barcode.length > 3 ? false : true
          }
        />
        <Valert
          display={false}
          title={t("general.OUT_RANGE_AMOUNT_TITLE")}
          question={
            this.props.symptomForm.category === "01"
              ? t("general.OUT_RANGE_SEVERITY_SYMPTOM_TEXT")
              : t("general.OUT_RANGE_AMOUNT_TEXT")
          }
          onRef={(ref) => (this.rangeCheck = ref)}
          positiveAction={() => {
            if (this.pendingCustomCheck && typeof this.pendingCustomCheck === "function") {
              const handled = this.pendingCustomCheck();
              this.pendingCustomCheck = null;
              if (handled) return;
            }

            if (this.state.updateMode) {
              const values = { ...this.props.symptomForm };
              const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
              values.backendScale = conversionresult.scale;
              values.backendUnit = conversionresult.unit;
              this.props.updateItem(this.props.symptomForm.showName);
              this.symptomFormRef.selectItemPos(); // ✅ Clear selectedVId
              this.setState({ updateMode: false });
            } else {
              const values = { ...this.props.symptomForm };
              const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
              values.backendScale = conversionresult.scale;
              values.backendUnit = conversionresult.unit;
              this.props.addItem(this.props.symptomForm);
            }
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            this.state.deleteNotUpdated
              ? t("general.CURRENT_ITEM_TITLE")
              : this.state.deleteNotAdded
                ? t("general.NEW_ITEM_TITLE")
                : t("general.DELETE_CONFIRMATION_TITLE")
          }
          question={
            this.state.deleteNotUpdated
              ? t("general.CURRENT_ITEM_DELETE_TEXT")
              : this.state.deleteNotAdded
                ? t("general.NEW_ITEM_DELETE_TEXT")
                : t("general.DELETE_CONFIRMATION_TEXT")
          }
          onRef={(ref) => (this.deleteValert = ref)}
          positiveAction={() => {
            this.props.deleteItem(this.deleteId);
            this.symptomFormRef.selectItemPos(true);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={this.props.saveError.type && this.props.saveError.type === "alreadyUsedRecipeName"}
          title={t("recipe.ALREADY_USED_RECIPE_NAME_TITLE")}
          question={t("recipe.ALREADY_USED_RECIPE_NAME_TEXT")}
          children={
            this.props.saveError && this.props.saveError.meta && this.props.saveError.meta.length > 0 && (
              <ListingText listing={this.props.saveError.meta.map(m => ({ value: m }))} />
            )
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.state.showDuplicateError}
          title={t("general.DUPLICATE_ENTRY_TITLE")}
          question={t("general.DUPLICATE_ENTRY_ERROR_TEXT")}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          positiveAction={() => {
            if (this.state.updateMode) {
              if (this.state.kitdata) {
                // Regimen update: no value check needed
                this.addKitPromptClicked();
                this.symptomFormRef.selectItemPos(); // ✅ Clear selectedVId
                this.setState({ updateMode: false });
              } else {
                // Individual item update
                if (this.pendingRangeCheck && typeof this.pendingRangeCheck === "function") {
                  const handled = this.pendingRangeCheck();
                  this.pendingRangeCheck = null;
                  if (handled) return;
                }
                // Final fallback: update item directly
                const values = { ...this.props.symptomForm };
                const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
                values.backendScale = conversionresult.scale;
                values.backendUnit = conversionresult.unit;
                this.props.updateItem(this.props.symptomForm.showName);
                this.symptomFormRef.selectItemPos(); // ✅ Clear selectedVId
                this.setState({ updateMode: false });
              }
            } else {
              if (this.state.kitdata) {
                this.addKitPromptClicked();
              } else {
                if (this.pendingRangeCheck && typeof this.pendingRangeCheck === "function") {
                  const handled = this.pendingRangeCheck();
                  this.pendingRangeCheck = null;
                  if (handled) return;
                }
                // Final fallback: add item directly
                const values = { ...this.props.symptomForm };
                const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
                values.backendScale = conversionresult.scale;
                values.backendUnit = conversionresult.unit;
                this.props.addItem(this.props.symptomForm);
              }
            }
          }}
          negativeAction={() => {
            setTimeout(() => {
              this.setState({
                showDuplicateError: false,
              });
            }, 500);
            // this.negativeClicked();
          }}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.invalidValue = ref)}
          title={t("general.INVALID_VALUE_TITLE")}
          question={t("general.INVALID_VALUE_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.showDuplicateUnit = ref)}
          title={t("symptoms.MEASUREMENT_UNIT_PROMPT_TITLE")}
          question={
            t("symptoms.CHOOSE_UNIT_PROMPT_TEXT") +
            (Array.isArray(this.state.posunits)
              ? this.state.posunits.join(", ")
              : (this.state.posunits || "N/A")) + "."
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.barcodeCategoryRef}
          onRef={(ref) => (this.barcodeCategoryRef = ref)}
          title={this.props.t("BARCODE.INCOMPATIBLE_BARCODE_CATEGORY_TITLE")}
          question={
            this.props.refdb_item
              ? t(
                "BARCODE.INCOMPATIBLE_BARCODE_REFDB_CATEGORY_ON_SELECTED_CATEGORY_TEXT"
              ).replace(/{category}/g, this.props.refdb_item_category)
              : t(
                "BARCODE.INCOMPATIBLE_BARCODE_HISTORY_CATEGORY_ON_SELECTED_CATEGORY_TEXT"
              ).replace(/{category}/g, this.props.refdb_item_category)
          }
          negativeAction={() => {
            this.props.searchNameOptions("", "", true);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          positiveAction={() => {
            const categories = this.props.t("CATEGORIES", {
              returnObjects: true,
            });
            let categoryItem = categories.find(
              (item) => item.label === this.props.refdb_item_category
            );
            const refdb_item_category = categoryItem ? categoryItem.value : "";
            this.props.categorySelected({
              target: {
                value: refdb_item_category,
                type: "barcode_category",
              },
            });
            this.props.symptomOptionSelected(this.props.itemData);
            this.props.onDateChange(moment());

            if (this.props.showVerificationPrompt === true) {
              this.props.onChangeAlertStatus({
                showVerificationPrompt: false,
                itemInVerAutofill: true,
                barcodeCategoryRef: false,
              });
            }
          }}
        />
        <Valert
          display={this.props.barcodeCategory}
          onRef={(ref) => (this.barcodeCategory = ref)}
          title={t("symptoms.INCORECT_CATEGORY_TITLE")}
          question={t("symptoms.INCORECT_CATEGORY_TEXT")}
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.addCustomAlert}
          onRef={(ref) => (this.addCustomVAlert = ref)}
          title={t("BARCODE.OTHER_ENTRY_ERROR_TITLE")}
          question={
            this.props.symptomForm.category === "02"
              ? t("BARCODE.OTHER_ENTRY_ERROR_FOOD_CATEGORY_TEXT")
              : t("BARCODE.OTHER_ENTRY_ERROR_OTHER_CATEGORIES_TEXT")
          }
          positiveAction={() => {
            this.props.onDateChange("");
            this.setState({
              barcode: this.state.barcodeValue,
              displayAddCustomAlert: false,
            });
            this.setState({ barcodeValue: "" });
            this.barcodeAlertStatus.changeStatus();
            this.props.onChangeAlertStatus({
              item: { addCustomAlert: false },
            });
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.incorrectBarcodeCategory}
          title={this.props.t("BARCODE.INCORRECT_BARCODE_CATEGORY_TITLE")}
          question={t("BARCODE.INCOMPATIBLE_BARCODE_INCORRECT_CATEGORY_TEXT")}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeAction={() => {
            this.props.searchNameOptions("", "", true);
          }}
          positiveAction={() => {
            this.props.symptomOptionSelected(this.props.itemData);

            if (this.props.showVerificationPrompt === true) {
              this.props.onChangeAlertStatus({
                showVerificationPrompt: false,
                itemInVerAutofill: true,
                incorrectBarcodeCategory: false,
              });
            }
          }}
        />
        <Valert
          display={this.props.upc404}
          title={this.props.t("BARCODE.UPC404_ERROR_TITLE")}
          question={this.props.t("BARCODE.UPC404_ERROR_TEXT.TEXT")}
          positiveAction={async () => {
            await this.addBarcodeToField(); // Assign scanned/uploaded UPC to form
            if (!this.props.disabled.saveBtn) {
              sessionStorage.setItem("previousPageIsDirty", "input"); // Set previousPageIsDirty if Save Page button is enabled
            }
            if (this.selectedVId) {
              sessionStorage.setItem("selectedVId", this.selectedVId); // Store selectedVId to be retrieved after returning to Input Page
            }
            window.location.href = "/contribute?showBackBtn=true"; // Navigate to Contribute page
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          positiveText={this.props.t("general.CONTRIBUTE")}
          negativeText={this.props.t("general.CANCEL")}
          negativeAction={() => {
            this.props.searchNameOptions("", "", false, true);
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          onRef={(ref) => (this.contributeRedirectionAlert = ref)}
          disableAutoClose={true}
          thirdActionText={this.props.t("general.NEW")}
          ThirdAction={() => {
            this.props.searchNameOptions("", "", true);
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          children={<ListingText listing={this.props.listings} />}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.barcodeVerification = ref)}
          title={t("symptoms.BARCODE_VERIFICATION_TITLE")}
          question={t("symptoms.BARCODE_VERIFICATION_TEXT")}
          positiveAction={() => {
            this.addBarcodeToField();
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.barcodeFailed}
          onRef={(ref) => (this.barcodeFailed = ref)}
          title={t("BARCODE.BARCODE_ERROR_TITLE")}
          question={t("BARCODE.BARCODE_ERROR_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          title={t("general.INCOMPLETE_CHANGE_TITLE")}
          question={t("general.INCOMPLETE_CHANGE_TEXT")}
          onRef={(ref) => (this.IncompleteChangeToSelectedItem = ref)}
          positiveAction={this.submitAfterAsk}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("recipe.LAST_ITEM_TITLE")}
          question={t("general.SAVE_PAGE_UNSAVED_DATA_ERROR_TEXT")}
          onRef={(ref) => (this.LastItemNotAdded = ref)}
          positiveAction={this.submitAfterAsk}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("general.INCOMPLETE_ITEM_PROMPT_TITLE")}
          question={t("general.INCOMPLETE_ITEM_PROMPT_TEXT")}
          onRef={(ref) => (this.IncompleteLastItem = ref)}
          positiveAction={this.submitAfterAsk}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={t("general.SELECTED_ITEM_TITLE")}
          question={t("general.SAVE_PAGE_UPDATED_DATA_ERROR_TEXT")}
          onRef={(ref) => (this.SelectedItemNotUpdated = ref)}
          positiveAction={this.submitAfterAsk}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />

        <Valert
          display={false}
          question={t("symptoms.CLEAR_CONFIRMATION_TEXT")}
          title={t("general.CLEAR_CONFIRMATION_TITLE")}
          onRef={(ref) => (this.ClearConfirmation = ref)}
          positiveAction={this.clearSymptom}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("symptoms.OTHER_ENTRY_ERROR_TITLE")}
          question={t("symptoms.OTHER_ENTRY_ERROR_TEXT")}
          onRef={(ref) => (this.CustomItemNotIn12u12DB = ref)}
          positiveAction={() => {
            if (this.pendingCustomCheck && typeof this.pendingCustomCheck === "function") {
              const handled = this.pendingCustomCheck();
              this.pendingCustomCheck = null;
              if (handled) return;
            }
            if (this.state.updateMode) {
              const values = { ...this.props.symptomForm };
              const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
              values.backendScale = conversionresult.scale;
              values.backendUnit = conversionresult.unit;
              this.props.updateItem(this.props.selectedItem.showName);
              this.symptomFormRef.selectItemPos(); // ✅ Clear selectedVId
            } else {
              const values = { ...this.props.symptomForm };
              const conversionresult = convertHHMMForBackend(values.scale, values.unit); // Convert HHMM
              values.backendScale = conversionresult.scale;
              values.backendUnit = conversionresult.unit;
              this.props.addItem(this.props.symptomForm);
            }
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />
        {/* <Valert
          display={false}
          onRef={(ref) => (this.contContributeData = ref)}
          title={this.props.t("symptoms.OTHER_ENTRY_ERROR_TITLE")}
          question={this.props.t("symptoms.OTHER_ENTRY_ERROR_TEXT_1")}
          children={
            <div>
              <ul style={{ listStyleType: "disc", marginLeft: 12 }}>
                <li>{t("symptoms.OTHER_ENTRY_ERROR_TEXT_2")}</li>
                <li>{t("symptoms.OTHER_ENTRY_ERROR_TEXT_3")}</li>
                <li>{t("symptoms.OTHER_ENTRY_ERROR_TEXT_4")}</li>
              </ul>
            </div>
          }
          positiveAction={() => {
            window.location.href = "/contribute?showBackBtn=true";
            this.addBarcodeToField();
          }}
          negativeAction={() => {
            this.handleContributePrompt("Yes");
          }}
          positiveText={t("general.CONTRIBUTE")}
          negativeText={t("general.POSITIVE_PROMPT_TEXT")}
          thirdActionText={t("general.CANCEL")}
          ThirdAction={() => {
            this.handleContributePrompt("Cancel");
            this.props.onDateChange("");
          }}
        /> */}
        <Valert
          display={false}
          onRef={(ref) => (this.ProductNotContributed = ref)}
          title={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TITLE")}
          question={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TEXT")}
          positiveAction={this.addGreyUPC} // Call function to handle adding grey UPC to the Item Name field
          positiveText={t("general.CONTINUE_BUTTON")}
          negativeText={t("general.NEW")}
          negativeAction={() => {
            this.props.searchNameOptions("", "", true); // Clear UPC from Item Name field
            localStorage.removeItem("contDefault"); // ✅ Clear after clicking New button
            localStorage.removeItem("unContributed");
          }}
          children={
            <div style={{ fontSize: 14.4, color: "#555555", marginTop: 0 }}>
              <ul style={{ listStyleType: "disc", marginLeft: 12 }}>
                <li style={{ marginBottom: 5 }}>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET1_TEXT")}
                </li>
                <li>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET2_TEXT")}
                </li>
              </ul>
            </div>
          }
        />
        <MuiThemeProvider>
          <SymptomForm
            t={this.props.t}
            disabled={disabled}
            categorySelected={this.props.categorySelected}
            clearSymptom={this.props.clearSymptom}
            nameOptions={this.props.nameOptions}
            nameTotalOptions={this.props.nameTotalOptions}
            scaleOptions={this.props.scaleOptions}
            unitOptions={this.props.unitOptions}
            symptomForm={this.props.symptomForm}
            onDateChange={this.props.onDateChange}
            symptomOptionSelected={this.props.symptomOptionSelected}
            searchNameOptions={this.props.searchNameOptions}
            createSymptom={this.props.createSymptom}
            users={this.props.users}
            selectUser={this.props.selectUser}
            showList={this.props.showList}
            onRef={(ref) => {
              this.symptom = ref;
              this.symptomFormRef = ref;
            }}
            classNames={classNames}
            onChangeSymptomForm={onChangeSymptomForm}
            selectItem={selectItem}
            selectedList={selectedList}
            selectedItem={this.props.selectedItem}
            amounNewValue={amounNewValue}
            amountReseter={this.props.amountReseter}
            hhmmMode={this.props.hhmmMode}
            setHHMMMode={this.props.setHHMMMode}
            categories={categories}
            DeleteIconClicked={this.DeleteIconClicked}
            ingredientsModalHandler={this.ingredientsModalHandler}
            barcodeClicked={this.barcodeAlert}
            barcode={this.props.upc404}
            itemDetails={this.state.itemDetails}
            partialResult={this.props.partialResult}
            barcodeSearch={this.props.barcodeSearch}
            addCustomAlert={this.addCustomAlert}
            clearTime={this.clearTime}
            setTime={this.setTime}
            time={this.state.time}
            onVIdSelected={this.onVIdSelected}
            itemChanged={this.props.itemChanged}
            selectedVId={this.selectedVId}
            fetchRecentNames={this.props.fetchRecentNames}
            isLoading={this.props.isLoading}

            bodyMapClicked={this.bodyMapClicked.bind(this)}
            onDeleteCont={this.props.resetPage.bind(this)}
            barcodeImageClicked={this.barcodeImageClicked.bind(this)}
          />
        </MuiThemeProvider>
        <div className="row formRow">
          <div className="col">
            {!updateMode && cancelMode && (
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={() => {
                  this.props.updateItemCanceled(
                    this.props.selectedItem.vId,
                    this.props.selectedItem.completeItem
                  );
                  // ✅ Clear internal selected vId before calling selectItemPos
                  this.selectedVId = null;

                  this.setState(
                    {
                      selectedDetail: { item: null, vId: null },
                    },
                    () => {
                      this.symptomFormRef.selectItemPos(true); // Force deselect and preserve user
                      this.clearTime();
                    }
                  );
                }}
              >
                {t("general.CANCEL_ITEM_BUTTON")}
              </button>
            )}
            {updateMode && !cancelMode && (
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={this.UpdateItemClicked}
                disabled={disabled.addBtn ? "disabled" : ""}
              >
                {t("general.UPDATE_ITEM_BUTTON")}
              </button>
            )}
            {!updateMode && !cancelMode && (
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={this.AddItemClicked}
                disabled={disabled.addBtn ? "disabled" : ""}
              >
                {t("general.ADD_ITEM_BUTTON")}
              </button>
            )}
          </div>
          <div className="col">
            {updateMode && !cancelMode && (
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={() => {
                  this.props.updateItemCanceled(
                    this.props.selectedItem.vId,
                    this.props.selectedItem.completeItem
                  );
                  // ✅ Clear internal selected vId before calling selectItemPos
                  this.selectedVId = null;

                  this.setState(
                    {
                      selectedDetail: { item: null, vId: null },
                    },
                    () => {
                      this.symptomFormRef.selectItemPos(true); // Force deselect and preserve user
                      this.clearTime();
                    }
                  );
                }}
              >
                {t("general.CANCEL_ITEM_BUTTON")}
              </button>
            )}
            {!updateMode && (
              <button
                className="btn btn-primary btnWide"
                disabled={disabled.saveBtn ? "disabled" : ""}
                onClick={this.SavePageClicked}
              >
                {t("general.SAVE_PAGE_BUTTON")}
              </button>
            )}
          </div>
          <div className="col">
            <button
              type="button"
              className="btn btn-primary btnWide"
              onClick={this.ClearPageClicked}
              disabled={disabled.clearBtn ? "disabled" : ""}
            >
              {t("general.CLEAR_PAGE_BUTTON")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Symptom = translate("translations")(Symptom);

const mapStateToProps = (state) => ({ ...state.symptom });

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...symptomActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Symptom);



// WEBPACK FOOTER //
// ./src/pages/Symptom.js